<script setup lang="ts">
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import { useConfirmDialogState } from '@/components/common/useConfirmDialog'
import { useI18n } from 'vue-i18n'

const { isOpen, options, settle } = useConfirmDialogState()
const { t } = useI18n()
</script>

<template>
  <AlertDialog :open="isOpen" @update:open="(open) => !open && settle(false)">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{{ options.title }}</AlertDialogTitle>
        <AlertDialogDescription v-if="options.description">
          {{ options.description }}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <Button variant="outline" @click="settle(false)">
          {{ options.cancelLabel ?? t('common.cancel') }}
        </Button>
        <Button :variant="options.variant === 'destructive' ? 'destructive' : 'default'" @click="settle(true)">
          {{ options.confirmLabel ?? t('common.save') }}
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
